if (!window.__pcCartLoadingInitialized) {
  window.__pcCartLoadingInitialized = true;

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;

    const formComponent = form.closest('product-form-component');
    if (!formComponent) return;

    if (formComponent.hasAttribute('data-submitting')) return;

    const button = form.querySelector('button[type="submit"]:not(add-to-cart-component button)');
    if (!button) return;

    formComponent.setAttribute('data-submitting', 'true');
    button.setAttribute('data-loading', 'true');

    const cleanup = () => {
      formComponent.removeAttribute('data-submitting');
      button.removeAttribute('data-loading');
    };

    formComponent.addEventListener('cart:update', cleanup, { once: true });
    formComponent.addEventListener('cart:error', cleanup, { once: true });
  });
}
